import cacheFactory from "./cache.factory";
import SiteRepositoryStrategy from "./sites.strategy";
class SitesService {
  constructor() {
    this._siteRepositoryStrategy = SiteRepositoryStrategy.create();
    this.findAllSitesFromEnvironment = this.findAllSitesFromEnvironment.bind(
      this
    );
  }

  async findAll() {
    return await cacheFactory.getOrCreateDataFromCache(
      this.findAllSitesFromEnvironment
    );
  }

  async findAllSitesFromEnvironment() {
    return await this._siteRepositoryStrategy.findAll();
  }
}

export default new SitesService();
